export function SanitizeDate(dateString) {
  var sanitizeDateStr = null;
  var parsedDate = NaN;

  //this block below is supposed to be trimming invalid iso dates that have time appended e.g. 2009-01-21-07:00 -> 2009-01-21
  // (the first of many)...
  if (dateString.split("-").length - 1 > 2) {
    var firstBlock = dateString.indexOf("-");
    var secondBlock = dateString.indexOf("-", firstBlock + 1);
    var thirdBlock = dateString.indexOf("-", secondBlock + 1);
    sanitizeDateStr = dateString.substring(0, thirdBlock);
  }
  if (sanitizeDateStr) parsedDate = Date.parse(sanitizeDateStr);

  return parsedDate;
}
